// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_3TOZ4","img":"_3dk9a","spin":"_2chTF","imgWrapper":"wJCU5","addIcon":"_22dkC","deleteButton":"_1B63N"};